import { setLocale } from 'yup';

setLocale({
  mixed: {
    required: '${label} là bắt buộc'
  }
});
